import { defineComponent as p, ref as d, watch as P, createElementBlock as r, openBlock as l, createCommentVNode as s, createElementVNode as a, createVNode as u, unref as _, toDisplayString as g } from "vue";
import { ScalarIconCaretLeft as b, ScalarIconCaretRight as f } from "@scalar/icons";
import { findPreviousPage as N, findNextPage as k } from "../helpers/pageNavigation.js";
const x = { class: "t-editor__page-nav" }, y = {
  key: 0,
  class: "t-editor__page-nav__container"
}, C = { class: "t-editor__page-nav__item-label" }, T = { class: "t-editor__page-nav__item-label" }, I = /* @__PURE__ */ p({
  __name: "PageNav",
  props: {
    activePage: {},
    sidebar: {}
  },
  emits: ["goToNextPage", "goToPrevPage"],
  setup(n, { emit: m }) {
    const t = n, v = m, i = d(null), o = d(null);
    return P(
      [() => t.activePage, () => t.sidebar, () => t.sidebar?.items],
      () => {
        i.value = N(t.sidebar, t.activePage), o.value = k(t.sidebar, t.activePage);
      },
      {
        immediate: !0,
        deep: !0
      }
    ), (S, e) => (l(), r("div", x, [
      n.sidebar && (i.value || o.value) ? (l(), r("div", y, [
        i.value ? (l(), r("button", {
          key: 0,
          class: "t-editor__page-nav__item t-editor__page-nav__item-left",
          type: "button",
          onClick: e[0] || (e[0] = (c) => v("goToPrevPage", i.value))
        }, [
          a("div", C, [
            u(_(b)),
            e[2] || (e[2] = a("span", null, "Previous", -1))
          ]),
          a("b", null, g(n.sidebar.items[i.value]?.title), 1)
        ])) : s("", !0),
        o.value ? (l(), r("button", {
          key: 1,
          class: "t-editor__page-nav__item t-editor__page-nav__item-right",
          type: "button",
          onClick: e[1] || (e[1] = (c) => v("goToNextPage", o.value))
        }, [
          a("div", T, [
            e[3] || (e[3] = a("span", null, "Next", -1)),
            u(_(f))
          ]),
          a("b", null, g(n.sidebar.items[o.value]?.title), 1)
        ])) : s("", !0)
      ])) : s("", !0)
    ]));
  }
});
export {
  I as default
};
